// import { countersinkComponents } from 'metalworks-domain/src/__generated/admin-components/countersink.js'
import { ApplicationTypes } from 'metalworks-domain'
import { attachAdminComponent } from 'metalworks-domain/src/__generated/admin-implementation.js'

import { createAdminPages } from '@salsita-ai/platform-project-sdk/admin'
import {
  adminSidebarComponent,
  memoEval,
  navigationPageComponent,
  navigationPanelListComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { CountersinkSidebar, CountersinksPage, CountersinksPageActions } from './pages/CountersinksPage.js'
import { FeatureSettingSidebar, FeatureSettingsPage, FeatureSettingsPageActions } from './pages/FeatureSettingsPage.js'
import { MaterialPageActions, MaterialSidebar, MaterialsPage } from './pages/MaterialsPage.js'

const { commonComponents, commonPages } = createAdminPages({
  presets: {
    categoryNavigationState: ApplicationTypes.AdminNavigationState.PresetCategories,
    presetNavigationState: ApplicationTypes.AdminNavigationState.Presets,
  },
})

export const adminComponents = [
  ...commonComponents,
  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPageComponent, 'customMaterials')
    .withFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.Materials],
    })
    .attach(
      memoEval(
        () => [],
        () => {
          return {
            title: 'Materials',
            breadcrumbs: [
              {
                label: 'Materials',
                navigationState: ApplicationTypes.AdminNavigationState.Materials,
              },
            ],
            content: <MaterialsPage />,
            actions: <MaterialPageActions />,
          }
        }
      )
    ),
  attachAdminComponent
    .withEntity('CustomMaterial')
    .withComponent(adminSidebarComponent, 'customMaterialsSidebar')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.AdminNavigationState.Materials],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id],
        id => {
          return {
            title: 'Edit Material',
            page: <MaterialSidebar id={id} />,
          }
        }
      )
    ),
  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPageComponent, 'customCountersinks')
    .withFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.Countersinks],
    })
    .attach(
      memoEval(
        () => [],
        () => {
          return {
            title: 'Countersinks',
            breadcrumbs: [
              {
                label: 'Countersinks',
                navigationState: ApplicationTypes.AdminNavigationState.Countersinks,
              },
            ],
            content: <CountersinksPage />,
            actions: <CountersinksPageActions />,
          }
        }
      )
    ),
  attachAdminComponent
    .withEntity('Countersink')
    .withComponent(adminSidebarComponent, 'countersinkSidebar')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.AdminNavigationState.Countersinks],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id],
        id => {
          return {
            title: 'Edit Countersink',
            page: <CountersinkSidebar id={id} />,
          }
        }
      )
    ),
  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPageComponent, 'customFeatureSettings')
    .withFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.FeatureSettings],
    })
    .attach(
      memoEval(
        () => [],
        () => {
          return {
            title: 'Feature Settings',
            breadcrumbs: [
              {
                label: 'Feature Settings',
                navigationState: ApplicationTypes.AdminNavigationState.FeatureSettings,
              },
            ],
            content: <FeatureSettingsPage />,
            actions: <FeatureSettingsPageActions />,
          }
        }
      )
    ),
  attachAdminComponent
    .withEntity('FeatureSetting')
    .withComponent(adminSidebarComponent, 'featureSettingSidebar')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.AdminNavigationState.FeatureSettings],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id],
        id => {
          return {
            title: 'Edit Feature Setting',
            page: <FeatureSettingSidebar id={id} />,
          }
        }
      )
    ),
  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPanelListComponent, 'main')
    .attach(
      memoEval(
        () => [],
        () => {
          return {
            items: [
              ...commonPages,
              {
                label: 'Materials',
                icon: 'Palette',
                navigationStates: [ApplicationTypes.AdminNavigationState.Materials],
              },
              {
                label: 'Countersinks',
                icon: 'Circle',
                navigationStates: [ApplicationTypes.AdminNavigationState.Countersinks],
              },
              {
                label: 'Feature Settings',
                icon: 'Gear',
                navigationStates: [ApplicationTypes.AdminNavigationState.FeatureSettings],
              },
            ],
          }
        }
      )
    ),
]
